import { AutogenLayoutPayeeSummaryQuickInfo } from "./autogen/AutogenLayoutPayeeSummaryQuickInfo";

export class PayeeSummaryQuickInfo extends AutogenLayoutPayeeSummaryQuickInfo {

    onLoad(): void | Promise<void> {
        // Use a timeout to ensure DOM elements are fully rendered before applying styles
        setTimeout(() => {
            this.applyTopAlignment();
        }, 100);
    }

    private applyTopAlignment(): void {
        // Try multiple approaches to force top alignment

        // 1. Set CSS on the main panel
        if (this.panelPayeeList?.element) {
            const panelElement = this.panelPayeeList.element;
            panelElement.style.display = 'flex';
            panelElement.style.flexDirection = 'column';
            panelElement.style.justifyContent = 'flex-start';
            panelElement.style.alignItems = 'flex-start';
            panelElement.style.height = 'auto';
        }

        // 2. Set CSS on the table element
        if (this.tablePayees?.element) {
            const tableElement = this.tablePayees.element;
            tableElement.style.alignSelf = 'flex-start';
            tableElement.style.marginTop = '0';
        }

        // 3. Try setting on the root element
        if (this.element) {
            this.element.style.display = 'flex';
            this.element.style.flexDirection = 'column';
            this.element.style.justifyContent = 'flex-start';
            this.element.style.alignItems = 'stretch';
        }
    }
}
